module.exports = __webpack_public_path__ + "img/mobile-application-development.58310226.png";